import { ThousandAbbreviationPipe } from './thousand-abbreviation.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ThousandAbbreviationPipe],
  exports: [ThousandAbbreviationPipe]
})
export class ThousandAbbreviationPipeModule {}
